var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"shadow cursor-pointer hover:shadow-xl global_btn",class:`
  ${_vm.btnBorder ? `border border-${_vm.borderColor} ` : ''}
  bg-${_vm.btnColor} hover:bg-opacity-75
  text-${_vm.textColor}
  ${_vm.btnSizeVal === 'large' ? 'py-3 px-5 cta-text' : ''}
  ${_vm.btnSizeVal === 'medium' ? 'py-2 px-5 cta-text' : ''}
  ${_vm.btnSizeVal === 'small' ? 'py-1 px-3 heading-6' : ''}
  ${_vm.disabledBtn ? 'opacity-20 cursor-auto ' : ''}
  ${_vm.isSqure ? '' : 'rounded-full'}
  `,attrs:{"type":"button","disabled":_vm.disabledBtn},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.buttonHandler.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }